import {
  StyledInputField,
  StyledInputWrapper,
  StyledInputLabel,
  StyledFormItemField,
  StyledPasswordInputField,
} from "./style";
import type { TextInputFieldProps } from "./interfaces";

export const TextInputField = (props: TextInputFieldProps) => {
  return (
    <StyledInputWrapper style={props.style}>
      {props.label ? <StyledInputLabel>{props.label}</StyledInputLabel> : null}

      <StyledFormItemField name={props.name} rules={props.rules}>
        {props.type === "password" ? (
          <StyledPasswordInputField
            placeholder={props.placeholder}
            isEditable={props.isEditable}
          />
        ) : (
          <StyledInputField
            placeholder={props.placeholder}
            isEditable={props.isEditable}
          />
        )}
      </StyledFormItemField>
    </StyledInputWrapper>
  );
};
